export default __webpack_public_path__ + "images/ee-887a78f0eb107b3ce616a7fdf0feab97.svg";